import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations, Users } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { CookieComponent } from "@/assets/ts/components";
import store from "..";

export interface User {
  cEmail:string | null
  cHoTen:string | null
  cMatKhau:string | null
  cNguoiCapNhatCuoi:string | null
  cNguoiTao:string | null
  cSalt:string | null
  cSoDienThoai:string | null
  cTenCuaHang:string | null
  cTenNhomQuyen:string | null
  cTenTaiKhoan:string | null
  confirmPassword:string | null
  dNgayBatDau:string |Date | null
  dNgayCapNhatCuoi:string |Date | null
  dNgayKetThuc:string |Date | null
  dNgayTao:string |Date | null
  nMaCuaHang:number | null
  nMaNhomQuyen:number | null
  nMaTaiKhoan:number | null
  nShopIdOdoo:number | null
  nTinhTrang:number | null
  newPassword:string | null
  oldPassword:string | null
  token:string 
}

export interface UserAuthInfo {
  errors: Array<string>;
  user: User;
  isAuthenticated: boolean;
  perms: Array<string>;
}

@Module
export default class AuthModule extends VuexModule implements UserAuthInfo {
  errors = [];
  user = {} as User;
  isAuthenticated = !!JwtService.getToken();
  perms = [];


  get getPerms(): Array<string> {
    return this.perms;
  }

  /**
   * Get current user object
   * @returns User
   */
  get currentUser(): User {
    return this.user;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */
  get isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  /**
   * Get authentification errors
   * @returns array
   */
  get getErrors(): Array<string> {
    return this.errors;
  }


  @Mutation
  [Mutations.SET_PERMS](data) {
    this.perms = data;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = error;
  }

  @Mutation
  [Mutations.SET_AUTH](user) {
    this.isAuthenticated = true;
    this.user = user.data;
    this.errors = [];
    JwtService.saveToken(this.user.token);
    ApiService.setHeader();
    CookieComponent.set(
      "userData",
      JSON.stringify({ ...user.data, token: "" }),
      {}
    );
    CookieComponent.set("userName", this.user.cTenTaiKhoan as string, {});
    CookieComponent.set("fullName", this.user.cHoTen as string, {});
    CookieComponent.set("userEmail", this.user.cEmail as string, {});
    CookieComponent.set("token", this.user.token as string, {});
    CookieComponent.set("userTypeId", this.user.nMaNhomQuyen as number, {});
  }

  @Mutation
  [Mutations.SET_USER](user) {
    this.user = user;
  }

  @Mutation
  [Mutations.SET_PASSWORD](password) {
    this.user.cMatKhau = password;
  }

  @Mutation
  [Mutations.PURGE_AUTH]() {
    this.isAuthenticated = false;
    this.user = {} as User;
    this.errors = [];
    JwtService.destroyToken();
    CookieComponent.delete("userData");
    CookieComponent.delete("userName");
    CookieComponent.delete("fullName");
    CookieComponent.delete("userEmail");
    CookieComponent.delete("token");
    CookieComponent.delete("userTypeId");
  }

  @Action
  [Actions.ADD_PERMS](data) {
    this.context.commit(Mutations.SET_PERMS, data);
  }

  @Action
  [Actions.LOGIN](credentials) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("login", credentials)
        .then(async ({ data }) => {
          if (data.code == 200) {
            await this.context.commit(Mutations.SET_AUTH, data);
            store.dispatch(Users.findUserPermissions, {
              name: this.user.cTenTaiKhoan,
            });
          }
          resolve(data);
        })
        .catch(({ response }) => {
          if (response.data.errors)
            this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  }

  @Action
  [Actions.LOGOUT]() {
    CookieComponent.delete("system")
    this.context.commit(Mutations.PURGE_AUTH);
  }

  @Action
  [Actions.PURGE]() {
    this.context.commit(Mutations.PURGE_AUTH);
  }

  @Action
  [Actions.REGISTER](credentials) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("registration", credentials)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_AUTH, data);
          resolve();
        })
        .catch(({ response }) => {
          if (response.data.errors)
            this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  }

  @Action
  [Actions.FORGOT_PASSWORD](payload) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("forgot_password", payload)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_AUTH, data);
          resolve();
        })
        .catch(({ response }) => {
          if (response.data.errors)
            this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  }

  @Action
  [Actions.VERIFY_AUTH]() {
    if (CookieComponent.get("token")) {
      ApiService.setHeader();
      ApiService.post("getLoginUser", {})
        .then(({ data }) => {
          if (!data.data) {
            this.context.commit(Mutations.PURGE_AUTH);
          }
        })
        .catch(({ response }) => {
          if (response.data.errors) {
            this.context.commit(Mutations.SET_ERROR, response.data.errors);
            this.context.commit(Mutations.PURGE_AUTH);
          }
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  
  @Action
  [Actions.LOGIN_BY_BOOTH](params) {
      return new Promise<void>((resolve, reject) => {
        ApiService.post("loginByBooth", params).then(async ({ data }) => {
            if (data.code == 200) {
              await this.context.commit(Mutations.SET_AUTH, data);
            }
            resolve(data);
          })
          .catch(({ response }) => {
            if (response.data.errors)
              this.context.commit(Mutations.SET_ERROR, response.data.errors);
            reject(response);
          });
      });
  }

  @Action
    [Actions.RE_LOGIN](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/reLogin`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
  
}
